/* ==========================================================================
   MewBloom — storefront behaviour
   Everything here is progressive enhancement: with JavaScript off, every form
   still posts to Shopify and every page still works.
   ========================================================================== */

(function () {
  "use strict";

  var $ = function (sel, root) {
    return (root || document).querySelector(sel);
  };
  var $$ = function (sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  };

  /* ------------------------------------------------------------ cart drawer */

  var drawer = null;

  function getDrawer() {
    if (!drawer) drawer = document.getElementById("cart-drawer");
    return drawer;
  }

  function openDrawer() {
    var d = getDrawer();
    if (!d) return false;
    d.setAttribute("data-open", "true");
    d.removeAttribute("aria-hidden");
    document.body.classList.add("drawer-open");
    var closeBtn = $("[data-drawer-close]", d);
    if (closeBtn) closeBtn.focus({ preventScroll: true });
    return true;
  }

  function closeDrawer() {
    var d = getDrawer();
    if (!d) return;
    d.setAttribute("data-open", "false");
    d.setAttribute("aria-hidden", "true");
    document.body.classList.remove("drawer-open");
  }

  function setCount(count) {
    $$("[data-cart-count]").forEach(function (el) {
      el.textContent = count;
      if (count > 0) {
        el.removeAttribute("hidden");
      } else {
        el.setAttribute("hidden", "hidden");
      }
    });
  }

  /**
   * Re-render the drawer from Shopify's Section Rendering API so the markup is
   * always built by Liquid from the real cart object — never patched by hand.
   */
  function refreshDrawer() {
    return fetch(window.location.pathname + "?sections=cart-drawer", {
      headers: { Accept: "application/json" },
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        var html = data["cart-drawer"];
        if (!html) return;
        var parsed = new DOMParser().parseFromString(html, "text/html");
        var fresh = parsed.getElementById("cart-drawer");
        var current = getDrawer();
        if (!fresh || !current) return;
        current.innerHTML = fresh.innerHTML;
      });
  }

  function refreshCount() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        setCount(cart.item_count);
        return cart;
      });
  }

  function afterCartChange(open) {
    return Promise.all([refreshCount(), refreshDrawer()])
      .then(function () {
        if (open) openDrawer();
      })
      .catch(function () {
        window.location.href = "/cart";
      });
  }

  /* ------------------------------------------------------------ add to cart */

  function statusFor(form, message, state) {
    var el = $("[data-form-status]", form);
    if (!el) return;
    el.textContent = message || "";
    if (state) {
      el.setAttribute("data-state", state);
    } else {
      el.removeAttribute("data-state");
    }
  }

  function submitCartForm(form) {
    var button = form.querySelector("[type=submit]");
    var label = button ? button.textContent : "";
    if (button) {
      button.disabled = true;
      button.setAttribute("aria-busy", "true");
      button.textContent = "Adding…";
    }
    statusFor(form, "", null);

    fetch("/cart/add.js", {
      method: "POST",
      headers: { Accept: "application/json" },
      body: new FormData(form),
    })
      .then(function (res) {
        return res.json().then(function (body) {
          return { ok: res.ok, body: body };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          throw new Error(result.body.description || "That did not go through.");
        }
        return afterCartChange(true);
      })
      .catch(function (error) {
        statusFor(form, error.message || "That did not go through. Try again.", "error");
      })
      .then(function () {
        if (button) {
          button.disabled = false;
          button.removeAttribute("aria-busy");
          button.textContent = label;
        }
      });
  }

  /* ------------------------------------------------------------ cart edits */

  function changeLine(key, quantity) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        setCount(cart.item_count);
        return cart;
      });
  }

  /* ------------------------------------------------------------ gallery */

  function initGallery() {
    var main = $("[data-gallery-main]");
    if (!main) return;
    $$("[data-gallery-thumb]").forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var src = thumb.getAttribute("data-src");
        var srcset = thumb.getAttribute("data-srcset");
        if (!src) return;
        main.removeAttribute("srcset");
        if (srcset) main.setAttribute("srcset", srcset);
        main.setAttribute("src", src);
        $$("[data-gallery-thumb]").forEach(function (other) {
          other.setAttribute("aria-current", other === thumb ? "true" : "false");
        });
      });
    });
  }

  /* ------------------------------------------------------------ variants */

  function initVariants() {
    $$("[data-variant-select]").forEach(function (select) {
      select.addEventListener("change", function () {
        var option = select.options[select.selectedIndex];
        var idField = document.querySelector("[data-variant-id]");
        if (idField) idField.value = option.value;

        var priceEl = document.querySelector("[data-price]");
        if (priceEl && option.getAttribute("data-price")) {
          priceEl.textContent = option.getAttribute("data-price");
        }
        var stickyPrice = document.querySelector("[data-sticky-price]");
        if (stickyPrice && option.getAttribute("data-price")) {
          stickyPrice.textContent = option.getAttribute("data-price");
        }

        var available = option.getAttribute("data-available") === "true";
        $$("[data-buy-button]").forEach(function (button) {
          button.disabled = !available;
          button.textContent = available ? button.getAttribute("data-label") || "Add to basket" : "Sold out";
        });

        var url = option.getAttribute("data-url");
        if (url && window.history && window.history.replaceState) {
          window.history.replaceState({}, "", url);
        }
      });
    });
  }

  /* ------------------------------------------------------------ mobile nav */

  function initMobileNav() {
    var toggle = $("[data-menu-toggle]");
    var panel = $("[data-mobile-nav]");
    if (!toggle || !panel) return;
    toggle.addEventListener("click", function () {
      var open = panel.hasAttribute("hidden");
      if (open) {
        panel.removeAttribute("hidden");
      } else {
        panel.setAttribute("hidden", "hidden");
      }
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
    });
  }

  /* ------------------------------------------------------------ delegated */

  document.addEventListener("click", function (event) {
    var target = event.target;

    if (target.closest("[data-drawer-open]")) {
      event.preventDefault();
      if (!openDrawer()) window.location.href = "/cart";
      return;
    }

    if (target.closest("[data-drawer-close]")) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    if (target.closest("[data-drawer-overlay]")) {
      closeDrawer();
      return;
    }

    var removeBtn = target.closest("[data-drawer-remove]");
    if (removeBtn) {
      event.preventDefault();
      var key = removeBtn.getAttribute("data-drawer-remove");
      removeBtn.disabled = true;
      changeLine(key, 0)
        .then(function () {
          return refreshDrawer();
        })
        .catch(function () {
          window.location.href = "/cart";
        });
    }
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") closeDrawer();
  });

  document.addEventListener("submit", function (event) {
    var form = event.target;
    // Matches both the product form built by Shopify's form tag and the small
    // add forms on the product cards.
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
    event.preventDefault();
    submitCartForm(form);
  });

  /* ------------------------------------------------------------ boot */

  function boot() {
    initGallery();
    initVariants();
    initMobileNav();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  window.MewBloom = {
    openDrawer: openDrawer,
    closeDrawer: closeDrawer,
    refreshDrawer: refreshDrawer,
  };
})();
